<template>
  <div class="page_ruleSet">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>AI小杰</el-breadcrumb-item>
          <el-breadcrumb-item>{{activeName=='5' ? '入职参保规则' : '入职签约规则'}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <el-tabs v-model="activeName" type="card" @tab-click="changeTab">
          <el-tab-pane label="杰小薪设置" name="0"></el-tab-pane>
          <el-tab-pane label="杰小职设置" name="1"></el-tab-pane>
          <el-tab-pane label="杰小金设置" name="2"></el-tab-pane>
          <el-tab-pane label="任务缺省设置" name="3"></el-tab-pane>
          <!-- <el-tab-pane label="增强学习" name="4"></el-tab-pane> -->
          <el-tab-pane label="入职参保规则" name="5"></el-tab-pane>
          <el-tab-pane label="入职签约规则" name="6"></el-tab-pane>
        </el-tabs>

        <div class="ftabBtn flex">
          <el-button type="primary" size="small">导出</el-button>
          <el-button type="success" size="small" @click="addSet" v-if="activeName=='5'">添加项目配置</el-button>
          <el-button type="success" size="small" @click="addSet2" v-if="activeName=='6'">添加项目配置</el-button>
          <el-button type="danger" size="small">删除项目配置</el-button>
        </div>
        <el-table :data="tableData" border class="doc_table" @selection-change="handleSelectionChange" :max-height="tableHeight-100" v-loading="loading" style="width:100%">
          <el-table-column key="mul" type="selection" width="55" align="center" fixed="left"></el-table-column>
          <el-table-column prop="projectName" label="项目" min-width="160" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="typesOfInsurance" label="满足条件：险种（代码）" min-width="320" :show-overflow-tooltip="true" align="center" v-if="activeName=='5'">
            <template slot-scope="{row}">
              <div v-for="(item,index) in row.typesOfInsurance" :key="index">
                <div v-if="item.personnelCondition=='缺省'">
                  <span class="personnelCondition">缺省：</span>
                  <span>{{ item.险种名称 }}（ {{ item.代码 }} ）</span>
                </div>
                <div v-if="item.personnelCondition=='按年龄范围'">
                  <span class="personnelCondition">{{ item.年龄范围.最小年龄 + '岁 ≤ 年龄 ＜' + item.年龄范围.最大年龄 }}：</span>
                  <span>{{ item.险种名称 }}（ {{ item.代码 }} ）</span>
                </div>
                <div v-if="item.personnelCondition=='按岗位'">
                  <span class="personnelCondition">按岗位：</span>
                  <span> {{ item.参保岗位 }} | {{ item.险种名称 }}（ {{ item.代码 }} ）</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="jobAndCategory" label="岗位|职业类别" min-width="240" :show-overflow-tooltip="true" align="center" v-if="activeName=='5'">
            <template slot-scope="{row}">
              <div v-for="(item,index) in row.jobAndCategory" :key="index">
                <div v-if="item.personnelCondition=='缺省'">
                  <span class="personnelCondition">缺省：</span>
                  <span>{{ item.职业类别 }}</span>
                </div>
                <div v-if="item.personnelCondition=='按年龄范围'">
                  <span class="personnelCondition">{{ item.年龄范围.最小年龄 + '岁 ≤ 年龄 ＜' + item.年龄范围.最大年龄 }}：</span>
                  <span>{{ item.职业类别 }}</span>
                </div>
                <div v-if="item.personnelCondition=='按岗位'">
                  <span class="personnelCondition">按岗位：</span>
                  <span> {{ item.参保岗位 }} | {{ item.职业类别 }}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="employeeAttribute" label="员工属性" min-width="240" :show-overflow-tooltip="true" align="center" v-if="activeName=='5'">
            <template slot-scope="{row}">
              <div v-for="(item,index) in row.employeeAttribute" :key="index">
                <div v-if="item.personnelCondition=='缺省'">
                  <span class="personnelCondition">缺省：</span>
                  <span>{{ item.员工属性 }}</span>
                </div>
                <div v-if="item.personnelCondition=='按年龄范围'">
                  <span class="personnelCondition">{{ item.年龄范围.最小年龄 + '岁 ≤ 年龄 ＜' + item.年龄范围.最大年龄 }}：</span>
                  <span>{{ item.员工属性 }}</span>
                </div>
                <div v-if="item.personnelCondition=='按岗位'">
                  <span class="personnelCondition">按岗位：</span>
                  <span> {{ item.参保岗位 }} | {{ item.员工属性 }}</span>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="typesOfInsurance" label="满足条件 | 签约模板 | 合同/协议类型 | 合同时长" min-width="500" align="center" v-if="activeName=='6'">
            <template slot-scope="{row}">
              <div v-for="(item,index) in row.typesOfInsurance" :key="index">
                <div v-if="item.personnelCondition=='缺省'">
                  <span class="personnelCondition">缺省：</span>
                  <span>{{ item.template }} | {{ item.agreement }} | {{ item.duration +  item.unit}} </span>
                </div>
                <div v-if="item.personnelCondition=='按年龄范围'">
                  <span class="personnelCondition">{{ item.年龄范围.最小年龄 + '岁 ≤ 年龄 ＜' + item.年龄范围.最大年龄 }}：</span>
                  <span>{{ item.template }} | {{ item.agreement }} | {{ item.duration +  item.unit}} </span>
                </div>
                <div v-if="item.personnelCondition=='按岗位'">
                  <span class="personnelCondition">按岗位：</span>
                  <span>{{ item.岗位 }} | {{ item.template }} | {{ item.agreement }} | {{ item.duration +  item.unit}} </span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>

          <el-table-column label="操作" align="center" width="200" fixed="right">
            <template slot-scope={row}>
              <div class="injuryTabBtn">
                <el-button type="text" size="small" @click="editHandel(row)" v-if="activeName=='5'">编辑</el-button>
                <el-button type="text" size="small" @click="editHandel2(row)" v-if="activeName=='6'">编辑</el-button>
                <el-button type="text" size="small" @click="fieldSet(row)" v-if="activeName=='6'">字段赋值</el-button>
                <el-button type="text" size="small" @click="stopHandle(row,row.status=='启用'?3:2)">{{ row.status=='启用' ? '禁用' : '启用' }}</el-button>
                <el-popconfirm title="请确定是否作废" @confirm="stopHandle(row,1)">
                  <el-button type="text" slot="reference" style="margin-left: 10px;">作废</el-button>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="block">
          <el-pagination v-if="totalCount>0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <!-- 添加入职参保规则 -->
    <el-dialog :title="type=='add' ? '添加项目配置' : '修改'" :visible.sync="addVisible" width="850px" class="res_dialog enter_dialog">
      <el-form :rules="rules" ref="ruleForm" :model="ruleForm" class="" label-width="60px" size="small">
        <el-form-item label="项目:" prop="projectId">
          <el-select v-model="ruleForm.projectId" placeholder="" style="width:300px" filterable @change="changePro">
            <el-option v-for="item in projectList" :key="item.Id" :label="item.StrprojectName" :value="item.Projectid"></el-option>
          </el-select>
        </el-form-item>

        <div class="formTitle formTitle2"><span>|</span> 险种设置 </div>
        <el-table :data="ruleForm.typesOfInsurance" border class="doc_table" style="width:100%">
          <el-table-column prop="personnelCondition" label="人员情况" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="满足条件" min-width="300" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">
              <div v-if="ruleForm.typesOfInsurance.length>0">
                <div v-if="row.personnelCondition=='按年龄范围'">{{ row.年龄范围.最小年龄 + '岁 ≤ 年龄 ＜' + row.年龄范围.最大年龄}}</div>
                <div v-if="row.personnelCondition=='按岗位'">{{ row.参保岗位}}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="险种名称" label="险种名称" min-width="300" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="操作" min-width="100" align="center">
            <template slot-scope="{$index}">
              <div class="injuryTabBtn">
                <el-button type="text" size="small" @click="delItem(ruleForm.typesOfInsurance,$index)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="setItem flex">
          <el-select v-model="typesOfInsurance.personnelCondition" placeholder="请选择人员情况" size="small" style="width:140px;margin-right: 15px;" @change="(val)=>{changeType(val,'typesOfInsurance')}">
            <el-option value="缺省"></el-option>
            <el-option value="按年龄范围"></el-option>
            <el-option value="按岗位"></el-option>
          </el-select>

          <div class="yearBox flex" v-if="typesOfInsurance.personnelCondition=='按年龄范围'">
            <el-input v-model="typesOfInsurance.年龄范围.最小年龄" size="small" style="width:60px;margin-right: 5px;"></el-input>
            <div>岁 ≤ 年龄 ＜</div>
            <el-input v-model="typesOfInsurance.年龄范围.最大年龄" size="small" style="width:60px;margin-right: 5px;"></el-input>
            <div>岁</div>
          </div>
          <el-input v-model="typesOfInsurance.参保岗位" v-if="typesOfInsurance.personnelCondition=='按岗位'" placeholder="请输入岗位" size="small" style="width:180px;margin-right: 15px;"></el-input>

          <el-select v-model="typesOfInsurance.代码" placeholder="请选择险种" size="small" style="width:300px" @change="(val)=>{changeInsurance(val,'typesOfInsurance')}" filterable>
            <el-option v-for="(item,index) in insureList" :key="index" :label="item.Bntype" :value="item.InsuranceCode"></el-option>
          </el-select>

          <div class="flex aic cp addBox" style="margin-left:10px" @click="addRule">
            <i class="el-icon-circle-plus icon01"></i>
            <el-button type="text" style="margin-left:5px">添加</el-button>
          </div>
        </div>

        <div class="formTitle formTitle2"><span>|</span> 参保岗位和职业类别设置 </div>
        <el-table :data="ruleForm.jobAndCategory" border class="doc_table" style="width:100%">
          <el-table-column prop="personnelCondition" label="人员情况" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="满足条件" min-width="300" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">
              <div v-if="ruleForm.jobAndCategory.length>0">
                <div v-if="row.personnelCondition=='按年龄范围'">{{ row.年龄范围.最小年龄 + '岁 ≤ 年龄 ＜' + row.年龄范围.最大年龄}}</div>
                <div v-if="row.personnelCondition=='按岗位'">{{ row.参保岗位}}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="职业类别" label="职业类别" min-width="300" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="操作" min-width="100" align="center">
            <template slot-scope="{$index}">
              <div class="injuryTabBtn">
                <el-button type="text" size="small" @click="delItem(ruleForm.jobAndCategory,$index)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="setItem flex">
          <el-select v-model="jobAndCategory.personnelCondition" placeholder="请选择人员情况" size="small" style="width:140px;margin-right: 15px;" @change="(val)=>{changeType(val,'jobAndCategory')}">
            <el-option value="缺省"></el-option>
            <el-option value="按年龄范围"></el-option>
            <el-option value="按岗位"></el-option>
          </el-select>

          <div class="yearBox flex" v-if="jobAndCategory.personnelCondition=='按年龄范围'">
            <el-input v-model="jobAndCategory.年龄范围.最小年龄" size="small" style="width:60px;margin-right: 5px;"></el-input>
            <div>岁 ≤ 年龄 ＜</div>
            <el-input v-model="jobAndCategory.年龄范围.最大年龄" size="small" style="width:60px;margin-right: 5px;"></el-input>
            <div>岁</div>
          </div>
          <el-input v-model="jobAndCategory.参保岗位" v-if="jobAndCategory.personnelCondition=='按岗位'" placeholder="请输入岗位" size="small" style="width:180px;margin-right: 15px;"></el-input>

          <el-select v-model="jobAndCategory.职业类别" placeholder="请选择职业类别" size="small" style="width:300px">
            <el-option value="1-4类"></el-option>
            <el-option value="5"></el-option>
          </el-select>

          <div class="flex aic cp addBox" style="margin-left:10px" @click="addRule2">
            <i class="el-icon-circle-plus icon01"></i>
            <el-button type="text" style="margin-left:5px">添加</el-button>
          </div>
        </div>

        <div class="formTitle formTitle2"><span>|</span> 员工属性设置 </div>
        <el-table :data="ruleForm.employeeAttribute" border class="doc_table" style="width:100%">
          <el-table-column prop="personnelCondition" label="人员情况" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="满足条件" min-width="300" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">
              <div v-if="ruleForm.employeeAttribute.length>0">
                <div v-if="row.personnelCondition=='按年龄范围'">{{ row.年龄范围.最小年龄 + '岁 ≤ 年龄 ＜' + row.年龄范围.最大年龄}}</div>
                <div v-if="row.personnelCondition=='按岗位'">{{ row.参保岗位}}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="员工属性" label="员工属性" min-width="300" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="操作" min-width="100" align="center">
            <template slot-scope="{$index}">
              <div class="injuryTabBtn">
                <el-button type="text" size="small" @click="delItem(ruleForm.employeeAttribute,$index)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="setItem flex">
          <el-select v-model="employeeAttribute.personnelCondition" placeholder="请选择人员情况" size="small" style="width:140px;margin-right: 15px;" @change="(val)=>{changeType(val,'employeeAttribute')}">
            <el-option value="缺省"></el-option>
            <el-option value="按年龄范围"></el-option>
            <el-option value="按岗位"></el-option>
          </el-select>

          <div class="yearBox flex" v-if="employeeAttribute.personnelCondition=='按年龄范围'">
            <el-input v-model="employeeAttribute.年龄范围.最小年龄" size="small" style="width:60px;margin-right: 5px;"></el-input>
            <div>岁 ≤ 年龄 ＜</div>
            <el-input v-model="employeeAttribute.年龄范围.最大年龄" size="small" style="width:60px;margin-right: 5px;"></el-input>
            <div>岁</div>
          </div>
          <el-input v-model="employeeAttribute.参保岗位" v-if="employeeAttribute.personnelCondition=='按岗位'" placeholder="请输入岗位" size="small" style="width:180px;margin-right: 15px;"></el-input>

          <el-select v-model="employeeAttribute.员工属性" placeholder="请选择员工属性" size="small" style="width:300px">
            <el-option value="长期工"></el-option>
            <el-option value="临时工"></el-option>
            <el-option value="日结工"></el-option>
          </el-select>

          <div class="flex aic cp addBox" style="margin-left:10px" @click="addRule3">
            <i class="el-icon-circle-plus icon01"></i>
            <el-button type="text" style="margin-left:5px">添加</el-button>
          </div>
        </div>

        <div class="formTitle formTitle2"><span>|</span> 参保法务主体设置 </div>

        <el-form-item label="参保法务主体:" label-width="110px">
          <el-radio-group v-model="ruleForm.subjectType" @input="changeSubjectType">
            <el-radio :label="1">按个人签约法务主体</el-radio>
            <el-radio :label="2">指定法务主体</el-radio>
          </el-radio-group>
          <el-select v-model="ruleForm.subjectName" placeholder="" style="width:300px;margin-left: 15px;" filterable v-if="ruleForm.subjectType==2">
            <el-option v-for="(item,index) in legList" :key="index" :value="item.enterpriseName"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmAdd" size="small" :loading="isbtnLoading">确定</el-button>
      </span>
    </el-dialog>

    <!-- 入职签约规则 -->
    <el-dialog :title="type=='add' ? '添加项目配置' : '修改'" :visible.sync="addVisible2" width="1100px" class="res_dialog enter_dialog">
      <el-form :rules="rules" ref="ruleForm" :model="ruleForm" class="" label-width="60px" size="small">
        <el-form-item label="项目:" prop="projectId">
          <el-select v-model="ruleForm.projectId" placeholder="" style="width:180px" filterable @change="changePro">
            <el-option v-for="item in projectList" :key="item.Id" :label="item.StrprojectName" :value="item.Projectid"></el-option>
          </el-select>
        </el-form-item>

        <el-table :data="ruleForm.typesOfInsurance" border class="doc_table" style="width:100%">
          <el-table-column prop="personnelCondition" label="人员情况" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="满足条件" min-width="200" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">
              <div v-if="ruleForm.typesOfInsurance.length>0">
                <div v-if="row.personnelCondition=='按年龄范围'">{{ row.年龄范围.最小年龄 + '岁 ≤ 年龄 ＜' + row.年龄范围.最大年龄}}</div>
                <div v-if="row.personnelCondition=='按岗位'">{{ row.岗位}}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="template" label="签约模板" min-width="200" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="agreement" label="合同/协议类型" min-width="160" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="duration" label="协议期限" min-width="80" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">{{ row.duration + row.unit }}</template>
          </el-table-column>
          <el-table-column label="操作" min-width="100" align="center">
            <template slot-scope="{$index}">
              <div class="injuryTabBtn">
                <el-button type="text" size="small" @click="delItem(ruleForm.typesOfInsurance,$index)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="setItem flex">
          <el-select v-model="typesOfInsurance.personnelCondition" placeholder="人员情况" size="small" style="width:110px;margin-right: 15px;" @change="(val)=>{changeType(val,'typesOfInsurance')}">
            <el-option value="缺省"></el-option>
            <el-option value="按年龄范围"></el-option>
            <el-option value="按岗位"></el-option>
          </el-select>

          <div class="yearBox flex" v-if="typesOfInsurance.personnelCondition=='按年龄范围'">
            <el-input v-model="typesOfInsurance.年龄范围.最小年龄" size="small" style="width:45px;margin-right: 5px;"></el-input>
            <div>岁 ≤年龄＜ </div>
            <el-input v-model="typesOfInsurance.年龄范围.最大年龄" size="small" style="width:45px;margin-right: 5px;"></el-input>
            <div>岁</div>
          </div>
          <el-input v-model="typesOfInsurance.岗位" v-if="typesOfInsurance.personnelCondition=='按岗位'" placeholder="请输入岗位" size="small" style="width:140px;margin-right: 15px;"></el-input>

          <el-select v-model="typesOfInsurance.ContractSubject" placeholder="请选择签约主体" size="small" style="width:180px;margin-right: 15px;" filterable>
            <el-option v-for="(item,index) in legList" :key="index" :value="item.enterpriseName"></el-option>
          </el-select>

          <el-select v-model="typesOfInsurance.TempId" placeholder="请选择模板" clearable filterable style="width:180px;margin-right: 15px;" value-key="TempName" :disabled="!ruleForm.projectId" size="small" @change="changeTemp">
            <el-option v-for="(item,index) in tempList" :key="index" :label="item.TempName" :value="item.TempId"></el-option>
          </el-select>

          <el-select v-model="typesOfInsurance.agreement" value-key="name" placeholder="合同/协议列表" clearable filterable size="small" style="width:120px;margin-right: 15px;">
            <el-option v-for="(item,index) in contractList" :key="index" :value="item.name"></el-option>
          </el-select>

          <el-input v-model="typesOfInsurance.duration" placeholder="" size="small" style="width:60px;margin-right: 5px;" type="number"></el-input>
          <el-select v-model="typesOfInsurance.unit" value-key="name" placeholder="" size="small" style="width:60px;margin-right: 15px;">
            <el-option value="年"></el-option>
            <el-option value="月"></el-option>
            <el-option value="日"></el-option>
          </el-select>

          <div class="flex aic cp addBox" style="margin-left:10px" @click="addRule4">
            <i class="el-icon-circle-plus icon01"></i>
            <el-button type="text" style="margin-left:5px">添加</el-button>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addVisible2 = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmAdd" size="small" :loading="isbtnLoading">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="字段赋值" :visible.sync="showFieldSet" width="800px" class="res_dialog enter_dialog">
      <div class="container">
        <div class="table-header">
          <div>签约字段</div>
          <div>来源</div>
          <div>数据源字段</div>
        </div>
        <div class="field-row" v-for="(field, index) in fieldData" :key="index">
          <div class="field-name">{{ field.key }}</div>
          <div>
            <el-select v-model="fieldForm.data[index].source" placeholder="" style="width:180px" filterable @change="(val)=>{changeSource(val,field.item2,index)}" size="small">
              <el-option :label="getLabel(op.source)" :value="op.source" v-for="(op,i) in field.item2" :key="i"></el-option>
            </el-select>
          </div>
          <div>
            <!-- 输入框 -->
            <el-input v-model="fieldForm.data[index].inputContent" placeholder="" size="small" style="width:180px;margin-right: 5px;" v-if="field.inputType=='string'"></el-input>
            <!-- 数字 -->
            <el-input v-model="fieldForm.data[index].inputContent" placeholder="" size="small" type="number" style="width:180px;margin-right: 5px;" v-if="field.inputType=='number'"></el-input>
            <!-- 下拉选择 -->
            <el-select v-model="fieldForm.data[index].inputContent" placeholder="" style="width:180px" filterable size="small" v-if="field.inputType=='select'">
              <el-option :label="item.value" :value="item.key" v-for="(item,i) in field.dic" :key="i"></el-option>
            </el-select>
            <!-- 日期 -->
            <el-date-picker v-model="fieldForm.data[index].inputContent" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;" v-if="field.inputType=='date'">
            </el-date-picker>

            <!-- source==2/3 时，数据源字段 -->
            <el-select v-model="fieldForm.data[index].dataSourceNo" placeholder="" style="width:180px" filterable size="small" v-if="fieldForm.data[index].source==2">
              <el-option :label="item.value" :value="item.key" v-for="(item,i) in optionList2" :key="i"></el-option>
            </el-select>
            <el-select v-model="fieldForm.data[index].dataSourceNo" placeholder="" style="width:180px" filterable size="small" v-if="fieldForm.data[index].source==3">
              <el-option :label="item.value" :value="item.key" v-for="(item,i) in optionList3" :key="i"></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showFieldSet = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmSetField" size="small" :loading="isbtnLoading">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {
    create
  } from "mathjs";
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        tableHeight: Number(document.body.clientHeight),
        listQuery: {
          PageModel: {
            Rows: 10,
            Page: 1,
            OrderInput: []
          },
          taskType: 10, //10入职参保规则 20入职签约规则
        },
        ruleForm: {
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
          id: '',
          taskType: 10, //10入职参保规则 20入职签约规则
          projectId: null,
          projectName: '',
          status: '启用',
          insuranceId: '', //险种id
          typesOfInsurance: '', //险种内容/签约内容（满足条件）
          jobAndCategory: '', //参保岗位和职业类别
          employeeAttribute: '', //员工属性
          subjectType: 1,
          subjectName: '',
        },
        type: '',
        fileList: [],
        addVisible: false,
        isbtnLoading: false,
        showDropScreen: -1,
        activeName: '0',
        num1: 0,
        tableData: [],
        expandTable: [],
        roletype: localStorage.loginRoletype,
        totalCount: 0,
        loading: false,
        projectList: [], //项目列表
        multipleSelection: [],
        permissionLists: [],
        rules: {
          projectId: {
            required: true,
            message: "请选择项目",
            trigger: "change",
          }
        },
        typesOfInsurance: {}, //满足条件：险种（代码）
        jobAndCategory: {}, //岗位？|职业类别
        employeeAttribute: {}, //员工属性
        insureList: [], //险种列表
        addVisible2: false,
        legList: [],
        contractList: this.$store.state.EMP.contractList, //合同/协议列表
        tempList: [],
        showFieldSet: false,
        fieldData: [],
        fieldForm: [],
        optionList2: [],
        optionList3: [],
      }
    },
    created() {
      if (this.$route.query.activeName != undefined && this.$route.query.activeName) {
        this.activeName = this.$route.query.activeName;
        this.changeTab()
      } else {
        this.getList();
      }
      this.getProList();
      this.getbIlist();
      this.getLegalSubjectList();
      this.GetDataSourceNo(2, 'optionList2');
      this.GetDataSourceNo(3, 'optionList3');
      // this.getButtonPower();
      let d = '[{"project":1754,"status":"在职"},{"project":1567,"status":"在职"}]'
      console.log(JSON.parse(d))
    },
    methods: {
      checkPermission,
      //获取项目
      getProList() {
        let data = {
          projectname: "", // 项目名称
          projectid: "", // 项目id
          custname: "", //客户名称
          strAchieveowner: "", // 业绩归属人
          strservuserid: "", // 客服
          strBusiStat: "", //项目状态
          strpartner2: "", //合伙人
          perpage: 100000000,
          currpage: 1,
          strorgancode: "",
          roletype: this.roletype,
        }
        xz.getProjectLists(data).then((res) => {
          if (res.status == "ok") {
            this.projectList = res.msg;
          } else {
            this.projectList = [];
          }
        });
      },
      //取签约主体列表
      getLegalSubjectList() {
        xz.getLegalSubjectList('', this.roletype).then(res => {
          if (res.status == 'ok') {
            this.legList = res.data
          } else {
            this.$message.error('获取签约主体列表出错');
          }
        })
      },
      //获取商保列表
      getbIlist() {
        this.loading = true;
        let d = {
          ProjectName: '', //商保方案名称
          Bntype: '', //商保类别
          TypeWork: '', //工种类型
          pageNum: 1,
          pageSize: 100
        }
        xz.getInsurancManageList(d).then(res => {
          if (res.status == 'ok') {
            this.insureList = res.data.data;
          } else {
            this.$message.error('获取险种列表失败')
            this.insureList = [];
          }
        })
      },
      currentChange(val) {
        this.listQuery.PageModel.Page = Number(val);
        this.getList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.PageModel.Page = 1;
        this.listQuery.PageModel.Rows = val;
        this.getList();
      },
      searchHandle() {
        this.listQuery.PageModel.Page = 1;
        this.getList();
      },
      getList() {
        this.GetAdvancePageList();
      },
      GetAdvancePageList() {
        xz.RPAFun(this.listQuery, 'GetTaskEntryList').then(res => {
          if (res.status == 'ok') {
            res.data.data.forEach(e => {
              if (e.typesOfInsurance) {
                e.typesOfInsurance = JSON.parse(e.typesOfInsurance)
              } else {
                e.typesOfInsurance = []
              }

              if (e.jobAndCategory) {
                e.jobAndCategory = JSON.parse(e.jobAndCategory)
              } else {
                e.jobAndCategory = []
              }

              if (e.employeeAttribute) {
                e.employeeAttribute = JSON.parse(e.employeeAttribute)
              } else {
                e.employeeAttribute = []
              }
            });
            this.tableData = res.data.data;
            // console.log(this.tableData)
            this.totalCount = res.data.pageModel.totalCount;
            this.loading = false;
          } else {
            this.tableData = [];
            this.totalCount = 0;
            this.loading = false;
          }
        })
      },
      down(url) {
        var path = this.$store.state.EMP.imgPath + url;
        const aTag = document.createElement("a");
        aTag.href = path;
        aTag.click();
      },
      changeTab() {

        if (this.activeName == '0' || this.activeName == '1' || this.activeName == '2') {
          this.$router.push({
            path: '/settlementTask',
            query: {
              activeName: this.activeName
            }
          })
        } else if (this.activeName == '3') {
          this.$router.push({
            path: '/taskSet'
          })
        } else if (this.activeName == '4') {
          this.$router.push({
            path: '/dict'
          })
        } else if (this.activeName == '5' || this.activeName == '6') {
          this.listQuery.taskType = this.activeName == '5' ? 10 : 20;
          this.getList()
        }
      },
      addSet() {
        this.ruleForm = {
          id: '',
          taskType: this.listQuery.taskType, //10入职参保规则 20入职签约规则
          projectId: null,
          projectName: '',
          status: '启用',
          insuranceId: '',
          typesOfInsurance: [],
          jobAndCategory: [],
          employeeAttribute: []
        }
        this.typesOfInsurance = {
          personnelCondition: '',
          参保岗位: '',
          年龄范围: null,
          险种名称: '',
          代码: '',
        };
        this.jobAndCategory = {
          personnelCondition: '',
          参保岗位: '',
          年龄范围: null,
          职业类别: '',
        }
        this.employeeAttribute = {
          personnelCondition: '',
          参保岗位: '',
          年龄范围: null,
          员工属性: '',
        }
        this.type = 'add';
        this.addVisible = true;
      },
      editHandel(row) {
        this.isbtnLoading = false;
        this.ruleForm = row;
        this.typesOfInsurance = {
          personnelCondition: '',
          参保岗位: '',
          年龄范围: null,
          险种名称: '',
          代码: '',
        };
        this.jobAndCategory = {
          personnelCondition: '',
          参保岗位: '',
          年龄范围: null,
          职业类别: '',
        }
        this.employeeAttribute = {
          personnelCondition: '',
          参保岗位: '',
          年龄范围: null,
          员工属性: '',
        }
        this.type = 'edit';
        this.addVisible = true;
      },
      changePro() {
        let item = this.projectList.find(e => e.Projectid == this.ruleForm.projectId);
        this.ruleForm.projectName = item.StrprojectName;
        if (this.activeName == '6') {
          xz.templatesByProjectList(this.ruleForm.projectName, this.roletype).then(res => {
            if (res.status == 'ok') {
              this.tempList = res.data.tempList;
            } else {
              this.tempEleList = [];
            }
          })
        }
      },
      // 表格多选
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      batchRefresh() {
        if (this.multipleSelection.length > 0) {
          let arr = [];
          this.multipleSelection.forEach((e, i) => {
            arr.push(e.projectId)
            if (i == this.multipleSelection.length - 1) {
              let d = arr.toString();
              this.confirmRefresh(d);
            }
          });
        } else {
          this.$message.warning('请至少选择一条')
        }
      },
      stopHandle(row, type) {
        this.loading = true;
        let str = `?id=${row.id}&BusiType=${type}`
        xz.ArdCurStatGetFun('DisableInvalidatedEntryRule', str).then(res => {
          if (res.status == 'ok') {
            this.loading = false;
            this.getList();
            this.addVisible = false;
            this.$message.success("操作成功！");
          } else {
            this.loading = false;
            this.$message.error(res.msg);
          }
        })
      },
      changeType(val, list) {
        console.log(val, list)
        if (val == '缺省') {
          this[list].参保岗位 = '';
          this[list].年龄范围 = null;
        } else if (val == '按年龄范围') {
          this[list].参保岗位 = '';
          this[list].年龄范围 = {
            最小年龄: '',
            最大年龄: ''
          };
        } else if (val == '按岗位') {
          this[list].年龄范围 = null;
        }
      },
      changeInsurance(val) {
        let item = this.insureList.find(e => e.InsuranceCode == val)
        this.typesOfInsurance.险种名称 = item.Bntype;
      },
      //添加险种设置
      addRule() {
        if (!this.typesOfInsurance.代码) {
          this.$message.warning('请选择险种！');
          return
        }
        if (this.typesOfInsurance.personnelCondition == '按年龄范围') {
          if (!this.typesOfInsurance.年龄范围.最小年龄 || !this.typesOfInsurance.年龄范围.最大年龄) {
            this.$message.warning('请输入完整的年龄范围！');
            return
          }
        } else if (this.typesOfInsurance.personnelCondition == '按岗位') {
          if (!this.typesOfInsurance.参保岗位) {
            this.$message.warning('请输入岗位！')
            return
          }
        }
        this.ruleForm.typesOfInsurance.push(this.typesOfInsurance);
        this.typesOfInsurance = {
          personnelCondition: '',
          参保岗位: '',
          年龄范围: null,
          险种名称: '',
          代码: '',
        }
      },
      //删除行
      delItem(list, i) {
        list.splice(i, 1)
      },
      //添加参保岗位和职业类别设置
      addRule2() {
        if (!this.jobAndCategory.职业类别) {
          this.$message.warning('请选择职业类别！');
          return
        }
        if (this.jobAndCategory.personnelCondition == '按年龄范围') {
          if (!this.jobAndCategory.年龄范围.最小年龄 || !this.jobAndCategory.年龄范围.最大年龄) {
            this.$message.warning('请输入完整的年龄范围！');
            return
          }
        } else if (this.jobAndCategory.personnelCondition == '按岗位') {
          if (!this.jobAndCategory.参保岗位) {
            this.$message.warning('请输入岗位！')
            return
          }
        }
        this.ruleForm.jobAndCategory.push(this.jobAndCategory);
        this.jobAndCategory = {
          personnelCondition: '',
          参保岗位: '',
          年龄范围: null,
          职业类别: '',
        }
      },
      addRule3() {
        if (!this.employeeAttribute.员工属性) {
          this.$message.warning('请选择员工属性！');
          return
        }
        if (this.employeeAttribute.personnelCondition == '按年龄范围') {
          if (!this.employeeAttribute.年龄范围.最小年龄 || !this.employeeAttribute.年龄范围.最大年龄) {
            this.$message.warning('请输入完整的年龄范围！');
            return
          }
        } else if (this.employeeAttribute.personnelCondition == '按岗位') {
          if (!this.employeeAttribute.参保岗位) {
            this.$message.warning('请输入岗位！')
            return
          }
        }
        this.ruleForm.employeeAttribute.push(this.employeeAttribute);
        this.employeeAttribute = {
          personnelCondition: '',
          参保岗位: '',
          年龄范围: null,
          员工属性: '',
        }
      },
      confirmAdd() {
        this.$refs["ruleForm"].validate((valid) => {
          if (valid) {
            this.isbtnLoading = true;
            let d = JSON.parse(JSON.stringify(this.ruleForm));
            d.typesOfInsurance = JSON.stringify(d.typesOfInsurance);
            d.jobAndCategory = JSON.stringify(d.jobAndCategory);
            d.employeeAttribute = JSON.stringify(d.employeeAttribute);
            xz.RPAFun(d, 'CreateOrEditBaseTogetEntry').then(res => {
              if (res.status == 'ok') {
                this.getList();
                this.isbtnLoading = false;
                this.$message.success('保存成功');
                this.addVisible = false;
                this.addVisible2 = false;
              } else {
                this.isbtnLoading = false;
                this.$message.error(res.msg);
              }
            })
          }
        })
      },
      //入职签约规则
      addSet2() {
        this.ruleForm = {
          id: '',
          taskType: this.listQuery.taskType, //10入职参保规则 20入职签约规则
          projectId: null,
          projectName: '',
          status: '启用',
          insuranceId: '',
          typesOfInsurance: [],
          jobAndCategory: '',
          employeeAttribute: ''
        }
        this.typesOfInsurance = {
          personnelCondition: '',
          template: '', //模板
          TempId: '',
          agreement: '', //协议
          岗位: '',
          年龄范围: null,
          ContractSubject: '', //主体名称
          duration: '',
          unit: '年'
        };
        this.type = 'add';
        this.addVisible2 = true;
      },
      //新增入职签约规则 行
      addRule4() {
        if (!this.typesOfInsurance.ContractSubject) {
          this.$message.warning('请选择签约主体！');
          return
        } else if (!this.typesOfInsurance.TempId) {
          this.$message.warning('请选择签约模板！');
          return
        } else if (!this.typesOfInsurance.agreement) {
          this.$message.warning('请选择合同/协议类型！');
          return
        }
        if (this.typesOfInsurance.personnelCondition == '按年龄范围') {
          if (!this.typesOfInsurance.年龄范围.最小年龄 || !this.typesOfInsurance.年龄范围.最大年龄) {
            this.$message.warning('请输入完整的年龄范围！');
            return
          }
        } else if (this.typesOfInsurance.personnelCondition == '按岗位') {
          if (!this.typesOfInsurance.岗位) {
            this.$message.warning('请输入岗位！')
            return
          }
        }
        this.ruleForm.typesOfInsurance.push(this.typesOfInsurance);
        this.typesOfInsurance = {
          personnelCondition: '',
          template: '', //模板
          TempId: '',
          agreement: '', //协议
          岗位: '',
          年龄范围: null,
          ContractSubject: '', //主体名称
          duration: '',
          unit: '年'
        }
      },
      editHandel2(row) {
        this.ruleForm = row;
        this.typesOfInsurance = {
          personnelCondition: '',
          template: '', //模板
          TempId: '',
          agreement: '', //协议
          岗位: '',
          年龄范围: null,
          ContractSubject: '', //主体名称
          duration: '',
          unit: '年'
        };
        this.type = 'edit';
        this.changePro()
        this.addVisible2 = true;
      },
      changeTemp(val) {
        if (val) {
          let item = this.tempList.find(e => e.TempId == val)
          this.typesOfInsurance.template = item.TempName;
          console.log(this.typesOfInsurance)
        }
      },
      fieldSet(row) {
        this.isbtnLoading = false;
        let arr = [];
        row.typesOfInsurance.forEach(e => {
          arr.push(e.agreement)
        });
        let data = {
          agreements: arr
        }
        xz.TaskSetupFun(data, 'GetProtocolField').then(res => {
          if (res.status == 'ok') {
            this.fieldData = Object.entries(res.data).map(([key, values]) => ({
              key,
              item1: values.item1,
              item2: values.item2
            }));
            console.log(this.fieldData)
            this.fieldForm = {
              startWorkId: row.id,
              data: []
            }
            this.fieldData.forEach(e => {
              let d = {
                fieldNo: e.item1,
                source: null,
                dataSourceNo: null,
                inputContent: ''
              }
              this.fieldForm.data.push(d);
            });
            this.showFieldSet = true;
          } else {
            this.$message.error(res.msg);
          }
        })
      },
      //获取label名称
      getLabel(val) {
        let list = ['人员实名信息', '项目信息', '入职信息', '输入'];
        return list[val - 1]
      },
      //获取来源 2/3 下拉选项
      GetDataSourceNo(val, list) {
        let str = `GetDataSourceNo?Source=${val}`;
        xz.TaskSetupGetFun(str).then(res => {
          if (res.status == 'ok') {
            this[list] = res.data;
          } else {
            this[list] = []
          }
        })
      },
      changeSource(val, item, index) {
        let d = item.find(e => e.source == val)
        if (d.inputType == "select") {
          this.$set(this.fieldData[index], 'dic', d.dic)
        }
        this.$set(this.fieldData[index], 'inputType', d.inputType)
        // console.log(val,item,d)
      },
      confirmSetField() {
        this.isbtnLoading = true;
        xz.TaskSetupFun(this.fieldForm, 'SetSigningFieldSave').then(res => {
          if (res.status == 'ok') {
            this.$message.success('保存成功');
            this.showFieldSet = false;
            this.getList();
            this.isbtnLoading = false;
          } else {
            this.isbtnLoading = false;
            this.$message.error(res.msg);
          }
        })
      },
      changeSubjectType(){
        if(this.ruleForm.subjectType == 1){
          this.ruleForm.subjectName = '';
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .formTitle {
    font-weight: 600;
    font-size: 14px;
    margin-bottom: 15px;
    margin-top: 20px;
  }

  .formTitle span {
    color: #F59A23;
    font-size: 18px;
  }

  .setItem {
    margin-top: 10px;
  }

  .yearBox {
    height: 32px;
    line-height: 32px;
    margin-right: 15px;
  }

  .icon01 {
    color: #19bd92;
    font-size: 20px;
    cursor: pointer;
  }

  .icon02 {
    // color: #19bd92;
    font-size: 20px;
    cursor: pointer;
    margin-left: 5px;
    line-height: 32px;
  }

  .addBox {
    height: 32px;
    line-height: 32px;
  }

  .personnelCondition {
    font-weight: bold;
  }

  .table-header {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    background: #fafafa;
    padding: 12px 16px;
    border-bottom: 1px solid #e8e8e8;
    font-weight: bold;
  }

  .field-row {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    padding: 12px 16px;
    border-bottom: 1px solid #e8e8e8;
    align-items: center;
  }
</style>
<style>
  .page_ruleSet .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_ruleSet .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_ruleSet .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_ruleSet .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_ruleSet .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_ruleSet .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }
</style>